// extracted by mini-css-extract-plugin
module.exports = {"titleImage":"blog-module--titleImage--3lYOI","blogBox":"blog-module--blogBox--wMXMB","blogGalleryImage":"blog-module--blogGalleryImage--3HMsR"};